var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sm:tw-pb-8 tw-pb-4"},[_c('CLogin',{on:{"success-login":_vm.handleSuccessLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }